import React from "react";
import JobHeroSection from "../../components/JobsPage/JobHeroSection";
import CategoryCards from "../../components/JobsPage/CategoryCards";
import JobCards from "../../components/JobsPage/JobCards";
import GlobalPartnerSection from "../../components/home/GlobalPartnerSection";
import JobsByLocation from "../../components/JobsPage/JobsByLocation";
import ContactSection from "../../components/ContactSection";
import DownloadBrochure from "../../components/JobsPage/DownloadBrochure";

interface JobFilters {
  country: string;
  category: string;
  keyword: string;
}

const Jobs = () => {
  const [filters, setFilters] = React.useState<JobFilters>({
    country: "",
    category: "",
    keyword: "",
  });

  return (
    <main>
      <JobHeroSection onApplyFilters={setFilters} />
      <CategoryCards />
      <JobCards filters={filters} />
      <GlobalPartnerSection />
      <JobsByLocation />
      <DownloadBrochure/>
      <ContactSection />
    </main>
  );
};

export default Jobs;

